export const VENDOR_API=process.env.REACT_APP_API_URL||(['localhost','127.0.0.1'].includes(window.location.hostname)?'/api':'/api');
export async function vendorApi(path,options={}){
 const response=await fetch(VENDOR_API+path,{...options,credentials:'include'});
 const data=await response.json();
 if(!response.ok||data.status!=='success')throw Error(data.message||data.detail||'Unable to load vendor information');
 return data;
}
